var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalicia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E86E2C",
    d: "M0 0h18v18H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.686 6.448a.061.061 0 0 1-.036-.012 2.197 2.197 0 0 0-.457-.184c-.35-.106-.96-.237-1.895-.26.053.999.23 1.577.332 1.832l.013.031c.059.138.224.466.483.542a.062.062 0 0 1 .042.074l-1.103 7.504a.063.063 0 0 1-.062.054.063.063 0 0 1-.062-.054l-1.108-7.5a.062.062 0 0 1 .041-.078c.258-.075.423-.402.481-.538.107-.26.291-.842.346-1.868-.935.023-1.545.154-1.894.261a2.03 2.03 0 0 0-.457.186.06.06 0 0 1-.022.009.744.744 0 1 1-.014-1.486c.003 0 .007 0 .011.002a.063.063 0 0 1 .025.009s.14.088.456.185c.351.108.966.24 1.908.262-.024-.936-.155-1.544-.262-1.891a2.104 2.104 0 0 0-.186-.454.06.06 0 0 1-.005-.049.735.735 0 0 1 .456-.668.735.735 0 0 1 .284-.056.72.72 0 0 1 .74.732.068.068 0 0 1-.01.046 2 2 0 0 0-.182.45c-.107.347-.238.955-.263 1.89.941-.022 1.554-.152 1.905-.259.287-.088.428-.168.456-.185a.062.062 0 0 1 .04-.014.745.745 0 0 1 0 1.487Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalicia);
export default __webpack_public_path__ + "static/media/galicia.c3a2f59e0172077124cc4ccdf674364f.svg";
export { ForwardRef as ReactComponent };